<template>
    <transition name="right" mode="out-in">
        <keep-alive>
            <component :is="compName" v-bind.sync="editProps" />
        </keep-alive>
    </transition>
</template>
<script>
import DwzxbgsqBrowse from "./DwzxbgsqBrowse";
import DwzxbgsqEdit from "./DwzxbgsqEdit";
import DwzxbgsqForm from "./DwzxbgsqForm";
export default {
    name: "Dwzxbgsq",
    components: { DwzxbgsqBrowse, DwzxbgsqEdit, DwzxbgsqForm },
    data() {
        return {
            editProps: {
                // 当前记录ID
                dataId: null,
                // 是否编辑状态
                showEdit: false,
                showForm: false
            }
        };
    },
    computed: {
        compName() {
            if (this.editProps.showEdit === true) {
                return "DwzxbgsqEdit";
            } else if (this.editProps.showForm === true) {
                return "DwzxbgsqForm";
            } else {
                return "DwzxbgsqBrowse";
            }
        }
    }
};
</script>
